export default "__VITE_PUBLIC_ASSET__8a1de9ad__"